import { store } from 'app/store';
import axios from 'axios';
import { AirlineInfo } from 'store/airlineData/airlineData.interface';

import urls from 'utils/urls';

const state = store.getState();

export const getAirlineService: () => Promise<{ data: AirlineInfo }> = () => {
  try {
    const airlines = state.airline.data;
    if (airlines) {
      return Promise.resolve({ data: airlines });
    } else {
      return axios
        .get(urls.airlineProducts)
        .then((res) => {
          return { data: res.data.response as AirlineInfo };
        })
        .catch((err) => {
          throw err;
        });
    }
  } catch (ex) {
    return Promise.reject(ex);
  }
};
